import { render } from "./Services.vue?vue&type=template&id=39429b20"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=39429b20&lang=css"
script.render = render

export default script